module.exports = Ditap